import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "7",
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.3788 0.299269C11.0087 -0.0433213 10.4374 -0.043632 10.0669 0.298556L6.09492 3.96705L2.12299 0.298556C1.75249 -0.0436321 1.18114 -0.0433213 0.811018 0.299269C0.397827 0.681727 0.397827 1.33504 0.811018 1.7175L6.09492 6.60838L11.3788 1.7175C11.792 1.33504 11.792 0.681727 11.3788 0.299269Z",
  fill: "#0A0912"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };